import { HR_BASE_URL } from "./appConst";
import { axiosAuth } from "./common";
import { EMPLOYEE_BASE_URL } from "./appConst";

interface GetEmployeesParams {
  employee_code?: string;
  name?: string;
  email?: string;
}

export const getEmployee = async (params?: GetEmployeesParams) => {
  const api = axiosAuth();

  const queryParams: any = {};

  if (params?.employee_code) queryParams.employee_code = params.employee_code;
  if (params?.name) queryParams.name = params.name;
  if (params?.email) queryParams.email = params.email;

  const response = await api.get(`${HR_BASE_URL}/employees`, {
    params: queryParams,
  });
  return response.data.data.employees;
};

export const assignCustomer = async (
  employeeId: number,
  customerId: number,
) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.post(`/assign-customer`, {
    employee_id: String(employeeId),
    customer_id: String(customerId),
  });

  return data.data;
};

export const assignCustomers = async (
  employeeId: number,
  customerIds: number[],
) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.post(`/assign-customers`, {
    employee_id: employeeId,
    customer_ids: customerIds,
  });

  console.log(data.data);

  return data.data;
};
